/**
 * De que editora e escola é este login (RN-18: a matrícula só é única na escola).
 *
 * O contexto chega no link que a escola entrega (`/?tenant=…&school=…`). Ele é
 * guardado no aparelho porque o aluno volta depois por `/`, por um favorito ou
 * pelo atalho do PWA — e sem ele o login falharia com "matrícula ou senha
 * incorretas", uma mensagem que aponta para o lugar errado.
 *
 * Precedência: URL > aparelho > build (VITE_*). A URL vence para que o link de
 * outra escola, aberto no mesmo aparelho, troque o contexto.
 */

export interface LoginContext {
  schoolId: string
  tenantSlug: string
}

const CHAVE = 'lumina:login-context'

function lerGuardado(): Partial<LoginContext> {
  try {
    const bruto = window.localStorage.getItem(CHAVE)
    if (!bruto) return {}
    const valor = JSON.parse(bruto) as Partial<LoginContext>
    return {
      schoolId: typeof valor.schoolId === 'string' ? valor.schoolId : undefined,
      tenantSlug: typeof valor.tenantSlug === 'string' ? valor.tenantSlug : undefined,
    }
  } catch {
    return {}
  }
}

function guardar(contexto: LoginContext): void {
  try {
    window.localStorage.setItem(CHAVE, JSON.stringify(contexto))
  } catch {
    // Armazenamento bloqueado (aba anônima, política do navegador): o link
    // continua funcionando, só não é lembrado.
  }
}

export function resolveLoginContext(
  search: string = window.location.search,
  env: { VITE_SCHOOL_ID?: string; VITE_TENANT_SLUG?: string } = import.meta.env,
): LoginContext {
  const params = new URLSearchParams(search)
  const daUrl = { schoolId: params.get('school') ?? '', tenantSlug: params.get('tenant') ?? '' }
  if (daUrl.schoolId && daUrl.tenantSlug) {
    guardar(daUrl)
    return daUrl
  }
  const guardado = lerGuardado()
  return {
    schoolId: daUrl.schoolId || guardado.schoolId || env.VITE_SCHOOL_ID || '',
    tenantSlug: daUrl.tenantSlug || guardado.tenantSlug || env.VITE_TENANT_SLUG || 'demo',
  }
}
